<template>
  <div class="homeSlider__container">
    <home-intro />
    <div class="slider__container" v-if="!$store.state.About">
      <div class="checker">
        <div class="slider">
          <slider-img
            :url="'/img/sof.png'"
            :type="'profilo'"
            id="0"
            class="imga"
          />
          <slider-img
            v-for="(item, index) in dbPrjNum"
            :key="'prj-' + index"
            :url="item.data.image_home.url"
            :page="item.uid"
            :numSlid="index"
            class="imga"
            :id="index + 1"
            :val="index + 1"
          />
          <slider-img :type="'filler'"/>
        </div>
      </div>
    </div>
    <about-comp v-else class="aboutComp"/>
  </div>
</template>

<script>
import AboutComp from "./AboutComp.vue";
// import { nextTick } from 'vue'
import HomeIntro from "./HomeIntro.vue";
import SliderImg from "./SliderImg.vue";
export default {
  components: { SliderImg, HomeIntro, AboutComp },
  data() {
    return {
      ImgMar: "",
      scrollOffset: 0,
      scrolling: false,
      direction: "",
      prjN: 2,
      prjSel: -1,
      prj: [
        {
          title: "WeSchool",
          text: "A new identity for the Ed-Tech Italian Startup WeSchool",
        },
        {
          title: "WeSchool",
          text: "A new identity for the Ed-Tech Italian Startup WeSchool",
        },
      ],
    };
  },
  watch: {
    // "$store.state.homePrj": function () {
    //   console.log(this.$store.state.homePrj);
    //   this.translatePr(this.$store.state.homePrj);
    // },
  },
  computed: {
    // translatePrj() {
    //   console.log("gas");
    //   return this.translatePr(this.$store.state.HomePrj);
    // },
    dbPrjNum() {
      // this.observerProva
      return this.$store.state.Prj;
    },
  },
  methods: {
    translateSlider(e) {
      let slider = document.querySelector(".slider__container");
      let imgWidth = document.querySelector(
        ".sliderImage__container"
      ).offsetWidth;

      // if (e.deltaY < -20) {
      if (e < 0) {
        this.scrollOffset -= imgWidth + 16;
        console.log(e);
      }
      if (e > 0) {
        this.scrollOffset += imgWidth + 16;
      }
      console.log(this.scrollOffset);
      slider.style.transform = `translate(${this.scrollOffset}px)`;

      //   if(this.scrollOffset <= 0 ){
      //   this.scrollOffset+= -e.deltaY
      //   }
      //   slider.style.transform = `translate(${this.scrollOffset}px)`;
      //   console.log(e);
      //  console.log(slider)
    },
    translatePr(k) {
      let slider = document.querySelector(".slider");
      let imgWidth = document.querySelector(
        ".sliderImage__container"
      ).offsetWidth;

      // if (
      //   this.direction < 0 &&
      //   this.scrollOffset >= -1 * this.prjN * (imgWidth + 16)
      // ) {
      //   this.scrollOffset -= imgWidth + 16;
      // }
      // if (this.direction > 0 && this.scrollOffset < 0) {
      //   this.scrollOffset += imgWidth + 16;
      // }
      console.log(this.scrollOffset);
      console.log((imgWidth + 16) * k);
      slider.style.transform = `translate(${-(imgWidth + 16) * k}px)`;
      // this.scrolling = false;
    },
    translate() {
      if (this.scrolling) {
        let slider = document.querySelector(".slider__container");
        let imgWidth = document.querySelector(
          ".sliderImage__container"
        ).offsetWidth;

        if (
          this.direction < 0 &&
          this.scrollOffset >= -1 * this.prjN * (imgWidth + 16)
        ) {
          this.scrollOffset -= imgWidth + 16;
        }
        if (this.direction > 0 && this.scrollOffset < 0) {
          this.scrollOffset += imgWidth + 16;
        }
        console.log(this.scrollOffset);
        slider.style.transform = `translate(${this.scrollOffset}px)`;
        this.scrolling = false;
        //   if(this.scrollOffset <= 0 ){
        //   this.scrollOffset+= -e.deltaY
        //   }
        //   slider.style.transform = `translate(${this.scrollOffset}px)`;
        //   console.log(e);
        //  console.log(slider)
      }
    },
    observerProva() {
      console.log("SUCA");
      var callback = (entries) => {
        entries.forEach((entry) => {
          // const ratio = entry.intersectionRatio;
          const element = entry.boundingClientRect;
          // const element = entry.target;
          console.log(element);
        });
      };
      var options = {
        root: document.querySelector(".slider"),
        threshold: [0],
      };
      var targets = document.querySelectorAll(".imga");
      var observer = new IntersectionObserver(callback, options);
      // console.log(targets)
      targets.forEach((target) => observer.observe(target));
    },

    observerProv() {
      // await this.$nextTick(() => {
      var callback = (entries) => {
        // console.log("Male")
        // entries.forEach((entry) => {
        //   // const ratio = entry.intersectionRatio;
        //   const element = entry.boundingClientRect;
        //   // const element = entry.target;
        //   // console.log(element);
        //   console.log(entry.isIntersecting)
        //   // console.log(element.right)
        //   // if(element.right < this.ImgMar) console.log(entry.target.id)
        //   if(element.right < this.ImgMar) console.log(entry.target.id)
        //   // if(entry.boundingClientRect.left < 20) this.$store.commit("forwardPrj", 1);
        // }
        // );
        // console.log(entries)
        entries.forEach((entry) => {
          // if(entry.intersectionRatio === 1)console.log(entry.target.id)
          if (entry.intersectionRatio === 1) {
            if (entry.target.id === 0) console.log("defaul");
            else this.$store.commit("choosePrj", parseInt(entry.target.id));
          }
        });
        // for(var i = 1; i < entries.length; i++){
        //   // console.log("test" + entries[0].target.id)
        //   console.log("suca " + i )
        //   if(entries[i].isIntersecting) console.log(entries[i].target.id)
        //   else console.log("nada")
        // }
      };
      var options = {
        root: document.querySelector(".checker"),
        threshold: [1],
      };
      var targets = document.querySelectorAll(".imga");
      var observer = new IntersectionObserver(callback, options);
      // console.log(targets)
      targets.forEach((target) => observer.observe(target));
      // });
    },
  },
  mounted() {
    this.ImgMar = document.getElementById("0").getBoundingClientRect().left;
    console.log(this.ImgMar);
    setTimeout(this.observerProv, 500);
    // this.observerProv
    // this.$nextTick(() => {
    //   var callback = (entries) => {
    //     entries.forEach((entry) => {
    //       // const ratio = entry.intersectionRatio;
    //       const element = entry.boundingClientRect;
    //       // const element = entry.target;
    //       console.log(element);
    //     });
    //   };
    //   var options = {
    //     root: document.querySelector(".slider"),
    //     threshold: [0],
    //   };
    //   var targets = document.querySelectorAll(".imga");
    //   var observer = new IntersectionObserver(callback, options);
    //   // console.log(targets)
    //   targets.forEach((target) => observer.observe(target));
    // });

    // var callback = (entries) => {
    //   entries.forEach((entry) => {
    //     // const ratio = entry.intersectionRatio;
    //     const element = entry.boundingClientRect;
    //     // const element = entry.target;
    //     console.log(element);
    //   });
    // };
    // var options = {
    //   root: document.querySelector(".slider"),
    //   threshold: [0],
    // };
    // var targets = document.querySelectorAll(".imga");
    // var observer = new IntersectionObserver(callback, options);
    // // console.log(targets)
    // targets.forEach((target) => observer.observe(target));

    // this.translatePr(this.$store.state.homePrj)
    //   window.addEventListener("wheel", (e) => {
    //     this.scrolling = true;
    //     this.direction = e.deltaY;
    //   });
    //   setInterval(() => this.translate(), 500);
    // },
    // beforeDestroy() {
    //   window.removeEventListener("wheel", (e) => this.translateSlider(e));
    //   clearInterval(() => this.translate(), 500);
  },
};
</script>

<style lang="scss" scoped>
.homeSlider__container {
  position: relative;
  //  background: red;
  width: 100vw;
  height: 85vh;
  overflow-x: hidden;
  @media screen and (max-width: 767px) {
    display: flex;
    padding-left: 20px;
    flex-direction: column-reverse;
    padding-top: 20vh;
    //  height: 70vh;
    justify-content: flex-end;
    height: auto;
  }

  ///////////////////
}
.slider__container {
  // flex-direction: column;
  // justify-content: flex-start;
  height: 100%;
  padding-top: 146px;
  padding-left: 33vw;

  @media screen and (max-width: 767px) {
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 5vh;
    height: 40vh;
  }
}
.slider {
  display: flex;
  width: 67vw;
  transition: 400ms ease-in-out;
  height: 100%;
  overflow-x: scroll;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -ms-scroll-snap-type: x mandatory;
  -ms-overflow-style: none;
  overflow-style: none;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
  @media screen and (max-width: 767px) {
    width: calc(100vw - 20px);
  }
}
.checker {
  // border: 1px solid red;
  // width: 340px;
  height: calc(85vh - 146px);
  width: calc((85vh - 146px) * 0.69);
  @media screen and (max-width: 767px) {
    width: calc(40vh * 0.69);
    height: 40vh;
  }
  // position: absolute;
}
.aboutComp{

}
</style>
